<template>
  <div style="display:none">
    <form ref="checkboxForm" method="POST" :action="target">
      <!-- Checkbox ValidData -->
      <input
        class="flex"
        v-if="formData.checkbox_ValidData.isPost"
        :name="formData.checkbox_ValidData.name"
        :value="registrationData.user.validData"
      />
      <!-- Checkbox CGU -->
      <input
        class="flex"
        v-if="formData.checkbox_CGU.isPost"
        :name="formData.checkbox_CGU.name"
        :value="registrationData.user.CGU"
      />
      <!-- Checkbox Newsletter -->
      <input
        class="flex"
        v-if="formData.checkbox_Newsletter.isPost"
        :name="formData.checkbox_Newsletter.name"
        :value="registrationData.user.newsletter"
      />
      <!-- Additionals Checkboxes -->
      <div
        class="flex flex-row"
        v-for="addCheckbox in additionalCheckboxes"
        :key="addCheckbox.id"
      >
        <input
          v-if="addCheckbox.checkboxFormType.isPost"
          class="flex"
          :name="addCheckbox.checkboxFormType.labelPost"
          :value="getValueAdditionalCheckbox(addCheckbox.id)"
        />
      </div>
    </form>
  </div>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
  name: "form-post-submit",

  components: {},

  props: {
    target: {
      type: String,
      required: true
    },
    formData: {
      type: Object,
      required: true
    },
    registrationData: {
      type: Object,
      required: true
    }
  },

  data() {
    return {};
  },

  computed: {
    additionalCheckboxes() {
      return this.formData.additionalCheckboxes
        .filter(f => f.visible)
        .filter(f => f.checkboxFormType.isActive)
        .sort((a, b) => a.order - b.order);
    }
  },

  methods: {
    getValueAdditionalCheckbox(idCheckbox) {
      return (
        this.registrationData.user.additionalCheckboxes[idCheckbox] ?? false
      );
    }
  },

  watch: {}
});
</script>

<style scoped></style>
